import React, { Component } from 'react';
import { obtenirArticle } from '../../services/PSP.service';
import './Article.js.css';
import { Chargement } from './Chargement';

export class Article extends Component {
    estMonte = false;

    constructor(props) {
        super(props)
        this.state = {
            article: null,
            enChargement: true,
        }
    }

    componentDidMount() {
        document.title = 'Article de loi ou règlement';
        this.estMonte = true;
        obtenirArticle().then(reponse => {
            const article = reponse;
            console.log(article)
            if (this.estMonte) {
                this.setState({ article: article, enChargement: false });
            }
        });
    }

    componentWillUnmount() {
        this.estMonte = false;
    }

    render() {
        const { enChargement, article } = this.state;

        if (enChargement) {
            return <Chargement />;
        }

        const { numeroArticle, libelle } = article;

        return (
            <div className='libelle'>
                <p>Article <strong>{numeroArticle}</strong></p>
                <div>{libelle}</div>
            </div>
        );
    }
}
